import { useMutation } from '@redwoodjs/web';

import { showErrorLong, showSuccessToast } from 'src/components/Toasts/toast';
import UPDATE_SUSPENDED_REASON from 'src/graphql/mutations/updateSuspendedReason.mutation';
import { LogError } from 'src/lib';

const useUpdateSuspendedReason = (onSuccess: () => void) => {
    const [updateSuspendedReason, { loading }] = useMutation(UPDATE_SUSPENDED_REASON, {
        onCompleted: ({ updateSuspendedReason: { message } }) => {
            showSuccessToast(message);
            onSuccess();
        },
        onError: (error) => {
            showErrorLong(error?.message);
            LogError(error);
        },
    });

    return {
        updatingSuspendedReason: loading,
        onUpdateSuspendedReason: async (updateSuspendedReasonInput) => {
            return await updateSuspendedReason({
                variables: {
                    input: updateSuspendedReasonInput,
                },
            });
        },
    };
};
export default useUpdateSuspendedReason;
